
import { Vue, Component, Prop } from 'vue-property-decorator'
import CloseCrossCtrl from '~/components/common/ctrls/CloseCrossCtrl.vue'

@Component({
  name: 'BasicModal',
  components: {
    CloseCrossCtrl
  }
})
export default class BasicModal extends Vue {
  @Prop({ default: '592px' }) maxWidth!: string
  @Prop({ default: '100%' }) width!: string
  @Prop() styles!: object
  @Prop() classes!: []
  @Prop({ default: true }) showCloseCtrl!: boolean
  @Prop({ type: Boolean, default: false }) hideOnOutsideClick!: boolean

  close() {
    this.$emit('close')
  }

  outsideClickHandler() {
    if (this.hideOnOutsideClick) {
      this.close()
    }
  }
}
